import { lazy } from 'react';
const AccordionComponent = lazy(() => import('./Accordion'));
const BreadcrumbsComponent = lazy(() => import('./Breadcrumbs'));
const BreadcrumbsComponent2 = lazy(() => import('./Breadcrumbs2'));
const LanguageComponent = lazy(() => import('./Language'));
const LoadingComponent = lazy(() => import('./Loading'));
const NoDataComponent = lazy(() => import('./NoData'));
const PaginationComponent = lazy(() => import('./Pagination'));
const ScrollbarComponent = lazy(() => import('./Scrollbar'));
const SpinnerComponent = lazy(() => import('./Spinner'));
const ProgressbarComponent = lazy(() => import('./Progressbar'));
const TableComponent = lazy(() => import('./Table'));
const InteractiveMapComponent = lazy(() => import('./InteractiveMap'));
const Table2Component = lazy(() => import('./Table2'));
export const Accordion = AccordionComponent;
export const Breadcrumbs = BreadcrumbsComponent;
export const Breadcrumbs2 = BreadcrumbsComponent2;
export const Language = LanguageComponent;
export const Loading = LoadingComponent;
export const NoData = NoDataComponent;
export const Pagination = PaginationComponent;
export const Scrollbar = ScrollbarComponent;
export const Spinner = SpinnerComponent;
export const Table = TableComponent;
export const Table2 = Table2Component;
export const InteractiveMap = InteractiveMapComponent;
export const ProgressBar = ProgressbarComponent;
